import React from 'react'

const Locks = ({ locks, adminCompanyIds, selectedLockIds, toggleLocks }) => (
  <div>
    {locks?.map((l, i) => {
      const disabled = adminCompanyIds.includes(l.company) || adminCompanyIds.includes(l.rentalCompany?.company)
      const isChecked = selectedLockIds.includes(l._id) || disabled

      const prev = locks[i - 1] 
      const isPreviousChecked = prev && (selectedLockIds.includes(prev._id) || adminCompanyIds.includes(prev.company) || adminCompanyIds.includes(prev.rentalCompany?.company))

      const isFirstUnchecked = !isChecked && isPreviousChecked /* if previous item is checked */

        return (
          <div key={l._id} style={{ opacity: disabled ? 0.5 : 1 }}>
            {isFirstUnchecked && <hr style={{ border: '2px solid #fff' }} />}
            <input disabled={disabled} type="checkbox" id={l._id} checked={isChecked} value={l._id} onChange={toggleLocks} />
            &nbsp;
            <label htmlFor={l._id}>{`${l.custom_name} - ${l.companyName || 'Okänt företag'} - Uthyrare: ${l.rentalCompany.name || 'Okänt uthyrningsföretag'}`}</label>
          </div>
        )
      })}
  </div>
)

export default Locks
